import M5APIs from "m5/M5APIs";
import moment from "moment";
import * as config from "../../../_config";

import { AssessModel } from "domains/models/AssessModel";
import { TaskModel } from "domains/models/TaskModel";
import { UserModel } from "domains/models/UserModel";
import { action, computed, makeAutoObservable, observable } from "mobx";
import { EmployeeModel } from "../../../domains/models/EmployeeModel";

class EmployeeDetailPageStore {
  @observable private _employee?: EmployeeModel;
  @observable private _originTaskList: Array<TaskModel> = [];
  @observable private _taskList: Array<TaskModel> = [];
  @observable private _pubDoneList: Array<TaskModel> = [];
  @observable private _prvDoneList: Array<TaskModel> = [];
  @observable private _pubAssessList: Array<AssessModel> = [];
  @observable private _prvAssessList: Array<AssessModel> = [];

  @observable _isReady: boolean = false;
  @observable _isLoading: boolean = false;
  @observable _isOpenModal: boolean = false;
  @observable _isCloseModal: boolean = false;
  @observable _isOpenEditModal: boolean = false;
  @observable _isCloseEditModal: boolean = false;
  @observable _tabsValue: string = "TODO";
  @observable _openPopper: boolean = false;
  @observable _emailCheck: boolean = false;
  @observable _chatCheck: boolean = false;
  @observable private _filterValue: string = "";
  @observable private _filterLikeUp: boolean = false;
  @observable private _filterLikeDown: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  setLoading(loading: boolean) {
    this._isLoading = loading;
  }

  @action
  setTabsValue(tabsValue: string) {
    this._tabsValue = tabsValue;
  }

  @action
  setIsOpenModal(isOpenModal: boolean) {
    this._isOpenModal = isOpenModal;
  }

  @action
  setIsCloseModal(isCloseModal: boolean) {
    this._isCloseModal = isCloseModal;
  }
  @action
  setIsOpenEditModal(isOpenEditModal: boolean) {
    this._isOpenEditModal = isOpenEditModal;
  }

  @action
  setIsCloseEditModal(isCloseEditModal: boolean) {
    this._isCloseEditModal = isCloseEditModal;
  }

  @action
  setEmployee(employee: EmployeeModel) {
    this._employee = employee;
  }

  @action
  setOpenPopper(openPopper: boolean) {
    this._openPopper = openPopper;
  }

  @action
  setEmailCheck(emailCheck: boolean) {
    this._emailCheck = emailCheck;
    this.filterListWithType();
  }

  @action
  setChatCheck(chatCheck: boolean) {
    this._chatCheck = chatCheck;
    this.filterListWithType();
  }

  fetchTaskListAPI = async (where: any) => {
    return await M5APIs.fetchDocs<TaskModel>(config.BUCKET_TASK!, "TASK", {
      // FIXME: of: me의 의미?
      // of: "me",
      page: 0,
      pageSize: 10,
      orderBy: "updated",
      orderDirection: "DESC",
      fetchChildrenJson: [
        {
          types: "ASSESS",
          page: 0,
          pageSize: 100,
        },
      ],
      where: where,
    });
  };

  @action
  async fetchMyTaskWithPeriod(userInfo: UserModel | undefined) {
    try {
      this._isLoading = true;
      // const res = await M5APIs.fetchDocs()
      console.log(this._filterValue);
      let period = {};
      let like = {};
      const curYear = moment().year();
      const curMonth = moment().month() + 1;
      if (this._filterValue === "quarter") {
        let startMonth = 0;
        let endMonth = 2;
        // 1분기
        if (moment().format("Q") === "1") {
          startMonth = 0;
          endMonth = 2;
        }
        // 2분기
        else if (moment().format("Q") === "2") {
          startMonth = 3;
          endMonth = 5;
        }
        // 3분기
        else if (moment().format("Q") === "3") {
          startMonth = 6;
          endMonth = 8;
        }
        // 4분기
        else {
          startMonth = 9;
          endMonth = 11;
        }
        let newDate = new Date(curYear, startMonth, 1);
        let newDate2 = new Date(curYear, endMonth, 31);
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment(newDate).valueOf(), moment(newDate2).valueOf()],
        };
      } else if (this._filterValue === "half") {
        let startMonth = 0;
        let endMonth = 2;
        //전반기 일떄
        if (curMonth < 7) {
          startMonth = 0;
          endMonth = 5;
        }
        //후반기 일때
        else {
          startMonth = 6;
          endMonth = 11;
        }
        let newDate = new Date(curYear, startMonth, 1);
        let newDate2 = new Date(curYear, endMonth, 31);
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment(newDate).valueOf(), moment(newDate2).valueOf()],
        };
      } else if (this._filterValue === "year") {
        let newDate = new Date(curYear, 0, 1);
        let newDate2 = new Date(curYear, 11, 31);
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment(newDate).valueOf(), moment(newDate2).valueOf()],
        };
      } else if (this._filterValue === "last30day") {
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment().subtract(1, "month").valueOf(), moment().valueOf()],
        };
      } else {
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment().subtract(1, "year").valueOf(), moment().valueOf()],
        };
      }
      if (this._filterLikeDown) {
        like = {
          condition: "AND",
          field: "userData.`like`",
          compare: "=",
          value: "false",
        };
      } else if (this._filterLikeUp) {
        like = {
          condition: "AND",
          field: "userData.`like`",
          compare: "=",
          value: "true",
        };
      }
      console.log(like);
      const response: any = await M5APIs.fetchDocs<TaskModel>(
        config.BUCKET_TASK!,
        "TASK",
        {
          // FIXME: of: me의 의미?
          // of: "me",
          page: 0,
          pageSize: 10,
          orderBy: "updated",
          orderDirection: "DESC",
          fetchChildrenJson: [
            {
              types: "ASSESS",
              page: 0,
              pageSize: 20000,
              where: {
                filters: [like],
              },
            },
          ],
          where: {
            filters: [
              period,
              {
                condition: "AND",
                field: "(",
              },
              {
                condition: "AND",
                field: "userData.`from`.`emailAddress`.`address`",
                compare: "=",
                value: this._employee?.email,
              },
              {
                condition: "OR",
                field: "userData.`from`.`user`.`id`",
                compare: "=",
                value: this._employee?.userData.graphId,
              },
              {
                field: ")",
              },
            ],
          },
        }
      );

      console.log(response);
      if (response?.docs) {
        response.docs.forEach((doc: TaskModel) => {
          let tempChildren: AssessModel[] = [];
          response.children?.forEach((child: any) => {
            if (doc.id === child.parentId) {
              tempChildren.push(child);
            }
          });
          doc.children = tempChildren;
        });

        let todoList: TaskModel[] = [];
        let doneList: TaskModel[] = [];
        console.log(userInfo);
        response.docs?.forEach((doc: TaskModel) => {
          if (userInfo) {
            if (
              doc.userData?.pubDoneIdList?.includes(userInfo.id) ||
              doc.userData?.prvDoneIdList?.includes(userInfo.id)
            ) {
              doneList.push(doc);
            } else {
              todoList.push(doc);
            }
          }
        });
        console.log(todoList, doneList);
        if (this._tabsValue === "TODO") {
          this._taskList = todoList;
          this._originTaskList = todoList;
        } else {
          this._taskList = doneList;
          this._originTaskList = doneList;
        }
      } else {
        this._taskList = [];
        this._originTaskList = [];
      }
    } catch (err: any) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  filterListWithType() {
    if (this._emailCheck && this._chatCheck) {
      this._taskList = this._originTaskList;
      return;
    }
    if (!this._emailCheck && !this._chatCheck) {
      this._taskList = [];
      return;
    }
    if (this._emailCheck && !this._chatCheck) {
      this._taskList = this._originTaskList.filter(
        (task: TaskModel) => task.subtype === "EMAIL"
      );
      return;
    }
    if (!this._emailCheck && this._chatCheck) {
      this._taskList = this._originTaskList.filter(
        (task: TaskModel) => task.subtype === "CHAT"
      );
      return;
    }
  }

  @action
  async fetchTaskList(userInfo: UserModel | undefined) {
    try {
      this._isLoading = true;
      console.log(this._employee);
      const response = await this.fetchTaskListAPI({
        filters: [
          {
            condition: "AND",
            field: "userData.`from`.`emailAddress`.`address`",
            compare: "=",
            value: this._employee?.email,
          },
          {
            condition: "OR",
            field: "userData.`from`.`user`.`id`",
            compare: "=",
            value: this._employee?.userData.graphId,
          },
        ],
      });
      console.log(response);

      if (response.docs) {
        response.docs.forEach((doc: TaskModel) => {
          let tempChildren: AssessModel[] = [];
          response.children?.forEach((child: any) => {
            if (doc.id === child.parentId) {
              tempChildren.push(child);
              if (userInfo?.id === child.userId) {
                if (child.subtype === "INVISIBLE") {
                  this._prvAssessList.push(child);
                }
                if (child.subtype === "VISIBLE") {
                  this._pubAssessList.push(child);
                }
              }
            }
          });
          doc.children = tempChildren;
        });

        let todoList: TaskModel[] = [];
        let doneList: TaskModel[] = [];
        console.log("USERINFO", userInfo);
        response.docs?.forEach((doc: TaskModel) => {
          if (userInfo) {
            if (
              doc.userData?.pubDoneIdList?.includes(userInfo.id) ||
              doc.userData?.prvDoneIdList?.includes(userInfo.id)
            ) {
              doneList.push(doc);
            } else {
              todoList.push(doc);
            }
          }
        });
        console.log(todoList, doneList);
        if (this._tabsValue === "TODO") {
          this._taskList = todoList;
          this._originTaskList = todoList;
        } else {
          this._taskList = doneList;
          this._originTaskList = doneList;
        }
      } else {
        this._taskList = [];
        this._originTaskList = [];
      }

      return response;
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  async fetchTaskByGroupwareId(
    userInfo: UserModel | undefined,
    gwid: string,
    processID: string,
    subject: string,
    ur_email: string,
  ) {

    console.log("fetchTaskByGroupwareId", userInfo, gwid, processID, ur_email,);
    let messageKey = "";

    // if (replyToId && replyToId !== "null" && messageId !== replyToId) {
    //   messageKey = `teams('${teamId}')/channels('${channelId}')/messages('${messageId}')/replies('${replyToId}')`;
    // } else {
    //   messageKey = `teams('${teamId}')/channels('${channelId}')/messages('${messageId}')`;
    // }

    // const doc = {
    //   type: "TASK",
    //   subtype: "GROUPWARE",      
    //   status: "TODO",
    //   substatus: processID,
    //   subcode: gwid,
    //   published: true,
    //   title: subject,
    //   subtitle: ur_email,
 
    // };


    try {
      this._isLoading = true;
 
      const response = await this.fetchTaskListAPI({
        filters: [
          {
            condition: "AND",
            field: "type",
            compare: "=",
            value: `TASK`,
          },
          {
            condition: "AND",
            field: "subtype",
            compare: "=",
            value: `GROUPWARE`,
          },
          {
            condition: "AND",
            field: "substatus",
            compare: "=",
            value: `${processID}`,
          },
          {
            condition: "AND",
            field: "subcode",
            compare: "=",
            value: `${gwid}`,
          },
          {
            condition: "AND",
            field: "userId",
            compare: "=",
            value: `${userInfo?.id}`,
          },
        ],
      });
      console.log(response);

      if (response.docs) {
        response.docs.forEach((doc: TaskModel) => {
          let tempChildren: AssessModel[] = [];
          response.children?.forEach((child: any) => {
            if (doc.id === child.parentId) {
              tempChildren.push(child);
              if (userInfo?.id === child.userId) {
                if (child.subtype === "INVISIBLE") {
                  this._prvAssessList.push(child);
                }
                if (child.subtype === "VISIBLE") {
                  this._pubAssessList.push(child);
                }
              }
            }
          });
          doc.children = tempChildren;
        });

        let todoList: TaskModel[] = [];
        let pubDoneList: TaskModel[] = [];
        let prvDoneList: TaskModel[] = [];
        //console.log("USERINFO", userInfo);
        response.docs?.forEach((doc: TaskModel) => {
          if (userInfo) {
            if (doc.userData?.pubDoneIdList?.includes(userInfo.id)) {
              pubDoneList.push(doc);
            }
            if (doc.userData?.prvDoneIdList?.includes(userInfo.id)) {
              prvDoneList.push(doc);
            }
            if (pubDoneList.length === 0 && prvDoneList.length === 0) {
              todoList.push(doc);
            }
          }
        });

        this._taskList = todoList;
        this._pubDoneList = pubDoneList;
        this._prvDoneList = prvDoneList;
      } else {
        this._taskList = [];
        this._prvDoneList = [];
        this._pubDoneList = [];
        this._originTaskList = [];
      }

      this._isReady = true;
      console.log("this._isReady", this._isReady);
      return { expired: false };
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
      console.log("this._isLoading", this._isLoading);
    }
  }


  @action
  async fetchTaskByEmailMessageId(
    userInfo: UserModel | undefined,
    messageId: string
  ) {
    try {
      this._isReady = false;
      console.log(
        `[debug.fetchTaskByMessageId] employee ${JSON.stringify(
          this._employee
        )}`
      );
      let response = await this.fetchTaskListAPI({
        filters: [
          {
            condition: "AND",
            field: "userData.`from`.`emailAddress`.`address`",
            compare: "=",
            value: this._employee?.email,
          },
          {
            condition: "and",
            field: "userData.`id`",
            compare: "=",
            value: messageId,
          },
        ],
      });

      if (!response.docs) {
      }

      if (response.docs) {
        response.docs.forEach((doc: TaskModel) => {
          let tempChildren: AssessModel[] = [];
          response.children?.forEach((child: any) => {
            if (doc.id === child.parentId) {
              tempChildren.push(child);
              if (userInfo?.id === child.userId) {
                if (child.subtype === "INVISIBLE") {
                  this._prvAssessList.push(child);
                }
                if (child.subtype === "VISIBLE") {
                  this._pubAssessList.push(child);
                }
              }
            }
          });
          doc.children = tempChildren;
        });

        let todoList: TaskModel[] = [];
        let pubDoneList: TaskModel[] = [];
        let prvDoneList: TaskModel[] = [];
        console.log("USERINFO", userInfo);
        response.docs?.forEach((doc: TaskModel) => {
          if (userInfo) {
            if (doc.userData?.pubDoneIdList?.includes(userInfo.id)) {
              pubDoneList.push(doc);
            }
            if (doc.userData?.prvDoneIdList?.includes(userInfo.id)) {
              prvDoneList.push(doc);
            }
            if (pubDoneList.length === 0 && prvDoneList.length === 0) {
              todoList.push(doc);
            }
          }
        });

        this._taskList = todoList;
        this._pubDoneList = pubDoneList;
        this._prvDoneList = prvDoneList;
      } else {
        this._taskList = [];
        this._prvDoneList = [];
        this._pubDoneList = [];
        this._originTaskList = [];
      }

      this._isReady = true;

      console.log("this._isReady", this._isReady);
      return response;
    } catch (err) {
      throw err;
    } finally {
      this._isReady = true;
    }
  }

  @action
  async fetchTaskByTeamsMessageId(
    userInfo: UserModel | undefined,
    channelId: string,
    teamId: string,
    messageId: string,
    replyToId: string,
    senderId: string
  ) {
    let messageKey = "";

    // if (replyToId && replyToId !== "null" && messageId !== replyToId) {
    //   messageKey = `teams('${teamId}')/channels('${channelId}')/messages('${messageId}')/replies('${replyToId}')`;
    // } else {
    //   messageKey = `teams('${teamId}')/channels('${channelId}')/messages('${messageId}')`;
    // }

    // if (replyToId && replyToId !== "null" && messageId !== replyToId) {
    //   messageKey = `/channels('${channelId}')/messages('${messageId}')/replies('${replyToId}')`;
    // } else {
    //   messageKey = `/channels('${channelId}')/messages('${messageId}')`;
    // }

    // console.log(`[DEBUG] messageKey = ${messageKey}`);

    // try {
    //   this._isLoading = true;
    //   console.log(
    //     `[debug.fetchTaskByTeamsMessageId] employee ${this._employee}`
    //   );
    //   const response = await this.fetchTaskListAPI({
    //     filters: [
    //       {
    //         condition: "AND",
    //         field: "title",
    //         compare: "LIKE",
    //         value: `%${messageKey}`,
    //       },
    //       {
    //         condition: "and",
    //         field: "userData.`from`.`user`.`id`",
    //         compare: "=",
    //         value: senderId,
    //       },
    //     ],
    //   });
    //   // console.log(response);

    //   if (response.docs) {
    //     response.docs.forEach((doc: TaskModel) => {
    //       let tempChildren: AssessModel[] = [];
    //       response.children?.forEach((child: any) => {
    //         if (doc.id === child.parentId) {
    //           tempChildren.push(child);
    //           if (userInfo?.id === child.userId) {
    //             if (child.subtype === "INVISIBLE") {
    //               this._prvAssessList.push(child);
    //             }
    //             if (child.subtype === "VISIBLE") {
    //               this._pubAssessList.push(child);
    //             }
    //           }
    //         }
    //       });
    //       doc.children = tempChildren;
    //     });

    //     let todoList: TaskModel[] = [];
    //     let pubDoneList: TaskModel[] = [];
    //     let prvDoneList: TaskModel[] = [];
    //     //console.log("USERINFO", userInfo);
    //     response.docs?.forEach((doc: TaskModel) => {
    //       if (userInfo) {
    //         if (doc.userData?.pubDoneIdList?.includes(userInfo.id)) {
    //           pubDoneList.push(doc);
    //         }
    //         if (doc.userData?.prvDoneIdList?.includes(userInfo.id)) {
    //           prvDoneList.push(doc);
    //         }
    //         if (pubDoneList.length === 0 && prvDoneList.length === 0) {
    //           todoList.push(doc);
    //         }
    //       }
    //     });

    //   this._taskList = todoList;
    //   this._pubDoneList = pubDoneList;
    //   this._prvDoneList = prvDoneList;
    // } else {
    this._taskList = [];
    this._prvDoneList = [];
    this._pubDoneList = [];
    this._originTaskList = [];

    this._isLoading = false;
    return { expired: false };

  }

  @action
  setFilterValue(value: string) {
    this._filterValue = value;
  }

  @action
  setFilterLikeDown(filterLikeDown: boolean) {
    this._filterLikeDown = filterLikeDown;
  }

  @action
  setFilterLikeUp(filterLikeUp: boolean) {
    this._filterLikeUp = filterLikeUp;
  }

  @computed
  get tabsValue() {
    return this._tabsValue;
  }

  @computed
  get taskList() {
    return this._taskList;
  }

  @computed
  get pubDoneList() {
    return this._pubDoneList;
  }
  @computed
  get prvDoneList() {
    return this._prvDoneList;
  }
  @computed
  get employee() {
    return this._employee;
  }
  @computed
  get pubAssessList() {
    return this._pubAssessList;
  }
  @computed
  get prvAssessList() {
    return this._prvAssessList;
  }
  @computed
  get isEmpty() {
    return this._taskList.length === 0;
  }
  @computed
  get isOpenModal() {
    return this._isOpenModal;
  }
  @computed
  get isCloseModal() {
    return this._isCloseModal;
  }
  @computed
  get isOpenEditModal() {
    return this._isOpenEditModal;
  }
  @computed
  get isCloseEditModal() {
    return this._isCloseEditModal;
  }
  @computed
  get openPopper() {
    return this._openPopper;
  }
  @computed
  get isLoading() {
    return this._isLoading;
  }

  @computed
  get isReady() {
    return this._isReady;
  }

  @computed
  get emailCheck() {
    return this._emailCheck;
  }

  @computed
  get chatCheck() {
    return this._chatCheck;
  }
  @computed
  get filterValue() {
    return this._filterValue;
  }

  @computed
  get filterLikeUp() {
    return this._filterLikeUp;
  }

  @computed
  get filterLikeDown() {
    return this._filterLikeDown;
  }
}

export default EmployeeDetailPageStore;
